export const PALETTES = [
  {
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.01,
        start: 0,
      },
      {
        color: '#ff1b00',
        end: 0.04,
        start: 0.01,
      },
      {
        color: '#ff2900',
        end: 0.07,
        start: 0.04,
      },
      {
        color: '#ff3300',
        end: 0.1,
        start: 0.07,
      },
      {
        color: '#ff4500',
        end: 0.13,
        start: 0.1,
      },
      {
        color: '#ff5300',
        end: 0.16,
        start: 0.13,
      },
      {
        color: '#ff6100',
        end: 0.19,
        start: 0.16,
      },
      {
        color: '#ff7000',
        end: 0.22,
        start: 0.19,
      },
      {
        color: '#ff7e00',
        end: 0.25,
        start: 0.22,
      },
      {
        color: '#ff8d00',
        end: 0.28,
        start: 0.25,
      },
      {
        color: '#ff9b00',
        end: 0.31,
        start: 0.28,
      },
      {
        color: '#ffa900',
        end: 0.34,
        start: 0.31,
      },
      {
        color: '#ffb800',
        end: 0.37,
        start: 0.34,
      },
      {
        color: '#ffd400',
        end: 0.4,
        start: 0.37,
      },
      {
        color: '#ffe200',
        end: 0.43,
        start: 0.4,
      },
      {
        color: '#fff000',
        end: 0.46,
        start: 0.43,
      },
      {
        color: '#fffe00',
        end: 0.49,
        start: 0.46,
      },
      {
        color: '#f1f600',
        end: 0.52,
        start: 0.49,
      },
      {
        color: '#e2ee00',
        end: 0.55,
        start: 0.52,
      },
      {
        color: '#d4e600',
        end: 0.58,
        start: 0.55,
      },
      {
        color: '#c6dd00',
        end: 0.61,
        start: 0.58,
      },
      {
        color: '#b8d500',
        end: 0.64,
        start: 0.61,
      },
      {
        color: '#aacd00',
        end: 0.67,
        start: 0.64,
      },
      {
        color: '#9cc400',
        end: 0.7,
        start: 0.67,
      },
      {
        color: '#8ebc00',
        end: 0.73,
        start: 0.7,
      },
      {
        color: '#7fb400',
        end: 0.76,
        start: 0.73,
      },
      {
        color: '#70ab00',
        end: 0.79,
        start: 0.76,
      },
      {
        color: '#62a300',
        end: 0.82,
        start: 0.79,
      },
      {
        color: '#549b00',
        end: 0.85,
        start: 0.82,
      },
      {
        color: '#469200',
        end: 0.88,
        start: 0.85,
      },
      {
        color: '#388a00',
        end: 0.91,
        start: 0.88,
      },
      {
        color: '#298200',
        end: 0.94,
        start: 0.91,
      },
      {
        color: '#1b7800',
        end: 0.97,
        start: 0.94,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.97,
      },
    ],
    name: 'SMS',
    selected: true,
  },
  {
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#01D8A3',
        end: 0.09,
        start: 0,
      },
      {
        color: '#80FFDF',
        end: 0.13,
        start: 0.09,
      },
      {
        color: '#89C8F1',
        end: 0.16,
        start: 0.13,
      },
      {
        color: '#729FFE',
        end: 0.2,
        start: 0.16,
      },
      {
        color: '#0059FF',
        end: 0.23,
        start: 0.2,
      },
      {
        color: '#0F0FFF',
        end: 0.26,
        start: 0.23,
      },
      {
        color: '#0000B5',
        end: 0.29,
        start: 0.26,
      },
      {
        color: '#230080',
        end: 0.32,
        start: 0.29,
      },
      {
        color: '#6C007B',
        end: 0.35,
        start: 0.32,
      },
      {
        color: '#9059EE',
        end: 0.39,
        start: 0.35,
      },
      {
        color: '#FC03CA',
        end: 0.42,
        start: 0.39,
      },
      {
        color: '#FE7CD0',
        end: 0.45,
        start: 0.42,
      },
      {
        color: '#FFBFFF',
        end: 0.48,
        start: 0.45,
      },
      {
        color: '#FF4242',
        end: 0.52,
        start: 0.48,
      },
      {
        color: '#FD0000',
        end: 0.55,
        start: 0.52,
      },
      {
        color: '#D50000',
        end: 0.59,
        start: 0.55,
      },
      {
        color: '#A00501',
        end: 0.62,
        start: 0.59,
      },
      {
        color: '#D28E02',
        end: 0.65,
        start: 0.62,
      },
      {
        color: '#FF8000',
        end: 0.68,
        start: 0.65,
      },
      {
        color: '#FBB940',
        end: 0.71,
        start: 0.68,
      },
      {
        color: '#FEF17A',
        end: 0.74,
        start: 0.71,
      },
      {
        color: '#FFFF00',
        end: 0.77,
        start: 0.74,
      },
      {
        color: '#DBF301',
        end: 0.81,
        start: 0.77,
      },
      {
        color: '#C5FD02',
        end: 0.84,
        start: 0.81,
      },
      {
        color: '#78F000',
        end: 0.88,
        start: 0.84,
      },
      {
        color: '#4AB900',
        end: 0.91,
        start: 0.88,
      },
      {
        color: '#2D9500',
        end: 0.94,
        start: 0.91,
      },
      {
        color: '#127700',
        end: 0.97,
        start: 0.94,
      },
      {
        color: '#005500',
        end: 1,
        start: 0.97,
      },
    ],
    name: 'Multicolor',
    selected: false,
  },
  {
    name: 'SMS 3',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.44,
        start: 0,
        rate: 2,
      },
      {
        color: '#b7b110',
        end: 0.78,
        start: 0.44,
        rate: 3,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.78,
        rate: 4,
      },
    ],
  },
  {
    name: 'SMS 4',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.36,
        start: 0,
        rate: 2,
      },
      {
        color: '#cf8900',
        end: 0.6,
        start: 0.36,
        rate: 3,
      },
      {
        color: '#75a000',
        end: 0.86,
        start: 0.6,
        rate: 4,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.86,
        rate: 5,
      },
    ],
  },
  {
    name: 'SMS 5',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.3,
        start: 0,
        rate: 2,
      },
      {
        color: '#db8000',
        end: 0.5,
        start: 0.3,
        rate: 3,
      },
      {
        color: '#b7b110',
        end: 0.7,
        start: 0.5,
        rate: 4,
      },
      {
        color: '#569400',
        end: 0.9,
        start: 0.7,
        rate: 5,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.9,
        rate: 6,
      },
    ],
  },
  {
    name: 'SMS 6',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.18,
        start: 0,
        rate: 2,
      },
      {
        color: '#e25f00',
        end: 0.44,
        start: 0.18,
        rate: 3,
      },
      {
        color: '#c69b00',
        end: 0.6,
        start: 0.44,
        rate: 4,
      },
      {
        color: '#90a900',
        end: 0.78,
        start: 0.6,
        rate: 5,
      },
      {
        color: '#458d00',
        end: 0.94,
        start: 0.78,
        rate: 6,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.94,
        rate: 7,
      },
    ],
  },
  {
    name: 'SMS 8',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.14,
        start: 0,
        rate: 2,
      },
      {
        color: '#eb4a00',
        end: 0.36,
        start: 0.14,
        rate: 3,
      },
      {
        color: '#d67b00',
        end: 0.49,
        start: 0.36,
        rate: 4,
      },
      {
        color: '#c2a200',
        end: 0.6,
        start: 0.49,
        rate: 5,
      },
      {
        color: '#9dad00',
        end: 0.74,
        start: 0.6,
        rate: 6,
      },
      {
        color: '#639900',
        end: 0.86,
        start: 0.74,
        rate: 7,
      },
      {
        color: '#338400',
        end: 0.99,
        start: 0.86,
        rate: 8,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.99,
        rate: 9,
      },
    ],
  },
  {
    name: 'SMS 10',
    selected: false,
    clip: {
      max: 1,
      min: 0,
    },
    colors: [
      {
        color: '#ff0e00',
        end: 0.1,
        start: 0,
        rate: 2,
      },
      {
        color: '#ef3d00',
        end: 0.2,
        start: 0.1,
        rate: 3,
      },
      {
        color: '#df6700',
        end: 0.3,
        start: 0.2,
        rate: 4,
      },
      {
        color: '#cf8900',
        end: 0.4,
        start: 0.3,
        rate: 5,
      },
      {
        color: '#bfa500',
        end: 0.5,
        start: 0.4,
        rate: 6,
      },
      {
        color: '#a4b000',
        end: 0.6,
        start: 0.5,
        rate: 7,
      },
      {
        color: '#75a000',
        end: 0.7,
        start: 0.6,
        rate: 8,
      },
      {
        color: '#4c9000',
        end: 0.8,
        start: 0.7,
        rate: 9,
      },
      {
        color: '#2a8000',
        end: 0.9,
        start: 0.8,
        rate: 10,
      },
      {
        color: '#0e7000',
        end: 1,
        start: 0.9,
        rate: 11,
      },
    ],
  },
] as const;

export const NDVI_VARIABILITY_PALETTE = {
  name: 'NDVI Variability',
  clip: {
    max: 1,
    min: 0,
  },
  colors: [
    {
      color: '#FF1C1D',
      end: 0.2,
      start: 0,
      rate: 1,
    },
    {
      color: '#FF9129',
      end: 0.4,
      start: 0.2,
      rate: 2,
    },
    {
      color: '#FFCF33',
      end: 0.6,
      start: 0.4,
      rate: 3,
    },
    {
      color: '#FFEF39',
      end: 0.8,
      start: 0.6,
      rate: 4,
    },
    {
      color: '#9DC72D',
      end: 1,
      start: 0.8,
      rate: 5,
    },
  ],
};

export const NDWI_PALETTE = {
  name: 'NDWI',
  clip: { min: -1, max: 1 },
  colors: [
    {
      color: '#d7191c',
      start: -1,
      end: -0.3,
      descriptionKey: 'map.palette_intervals.ndwi.drought',
    },
    {
      color: '#e4f4b6',
      start: -0.3,
      end: 0,
      descriptionKey: 'map.palette_intervals.ndwi.moderate_drought',
    },
    { color: '#7fbeac', start: 0, end: 0.2, descriptionKey: 'map.palette_intervals.ndwi.flooding' },
    { color: '#2b83ba', start: 0.2, end: 1, descriptionKey: 'map.palette_intervals.ndwi.water' },
  ],
};

export const NDMI_PALETTE = {
  name: 'NDMI',
  clip: { min: -1, max: 1 },
  colors: [
    {
      color: '#ff0e00',
      start: -1,
      end: 0,
      descriptionKey: 'map.palette_intervals.ndmi.negative_values',
    },
    {
      color: '#a6611a',
      start: 0,
      end: 0.05,
      descriptionKey: 'map.palette_intervals.ndmi.bare_soil',
    },
    {
      color: '#d7b46f',
      start: 0.05,
      end: 0.1,
      descriptionKey: 'map.palette_intervals.ndmi.sparse_vegetation',
    },
    {
      color: '#efe7d3',
      start: 0.1,
      end: 0.15,
      descriptionKey: 'map.palette_intervals.ndmi.low_moisture',
    },
    {
      color: '#d4eae6',
      start: 0.15,
      end: 0.2,
      descriptionKey: 'map.palette_intervals.ndmi.low_leaf_moisture',
    },
    {
      color: '#a2d8d0',
      start: 0.2,
      end: 0.3,
      descriptionKey: 'map.palette_intervals.ndmi.sufficient_leaf_moisture',
    },
    {
      color: '#6ec3b6',
      start: 0.3,
      end: 0.4,
      descriptionKey: 'map.palette_intervals.ndmi.ideal_leaf_moisture',
    },
    {
      color: '#38a493',
      start: 0.4,
      end: 0.5,
      descriptionKey: 'map.palette_intervals.ndmi.high_leaf_moisture',
    },
    {
      color: '#014dae',
      start: 0.5,
      end: 1,
      descriptionKey: 'map.palette_intervals.ndmi.very_high_moisture',
    },
  ],
};

export const LCI_PALETTE = {
  name: 'LCI',
  clip: { min: 0, max: 1 },
  colors: [
    {
      color: '#9c5228',
      start: 0,
      end: 0.15,
      descriptionKey: 'map.palette_intervals.lci.very_low_chlorophyll',
    },
    {
      color: '#cca92c',
      start: 0.15,
      end: 0.3,
      descriptionKey: 'map.palette_intervals.lci.low_chlorophyll',
    },
    {
      color: '#f1e913',
      start: 0.3,
      end: 0.45,
      descriptionKey: 'map.palette_intervals.lci.moderately_low_chlorophyll',
    },
    {
      color: '#cedc29',
      start: 0.45,
      end: 0.6,
      descriptionKey: 'map.palette_intervals.lci.moderate_chlorophyll',
    },
    {
      color: '#a0c23b',
      start: 0.6,
      end: 0.75,
      descriptionKey: 'map.palette_intervals.lci.moderately_high_chlorophyll',
    },
    {
      color: '#72a140',
      start: 0.75,
      end: 0.9,
      descriptionKey: 'map.palette_intervals.lci.high_chlorophyll',
    },
    {
      color: '#347238',
      start: 0.9,
      end: 1,
      descriptionKey: 'map.palette_intervals.lci.very_high_chlorophyll',
    },
  ],
};

export const NDRE_PALETTE = {
  name: 'NDRE',
  clip: { min: 0, max: 1 },
  colors: [
    {
      color: '#9c5228',
      start: 0,
      end: 0.15,
      descriptionKey: 'map.palette_intervals.ndre.very_low_vigour',
    },
    {
      color: '#cca92c',
      start: 0.15,
      end: 0.3,
      descriptionKey: 'map.palette_intervals.ndre.low_vigour',
    },
    {
      color: '#f1e913',
      start: 0.3,
      end: 0.45,
      descriptionKey: 'map.palette_intervals.ndre.moderately_low_vigour',
    },
    {
      color: '#cedc29',
      start: 0.45,
      end: 0.6,
      descriptionKey: 'map.palette_intervals.ndre.moderate_vigour',
    },
    {
      color: '#a0c23b',
      start: 0.6,
      end: 0.75,
      descriptionKey: 'map.palette_intervals.ndre.moderately_high_vigour',
    },
    {
      color: '#72a140',
      start: 0.75,
      end: 0.9,
      descriptionKey: 'map.palette_intervals.ndre.high_vigour',
    },
    {
      color: '#347238',
      start: 0.9,
      end: 1,
      descriptionKey: 'map.palette_intervals.ndre.very_high_vigour',
    },
  ],
};

export default PALETTES;
